export default "__VITE_ASSET__DH4hJ_El__"